// extracted by mini-css-extract-plugin
export var deliveryRow = "_ss-a";
export var fixedHeight = "_ss-4";
export var freightLogo = "_ss-9";
export var fullWidth = "_ss-3";
export var priceColumn = "_ss-5";
export var radioSelected = "_ss-7";
export var radioUnselected = "_ss-6";
export var selectedOption = "_ss-2";
export var selectedOptionContainer = "_ss-1";
export var selection = "_ss-0";
export var tallSkeletonText = "_ss-8";